import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  orders: []
}

export const orderSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    
    updateOrders: (state, action) => {
      state.orders = action.payload
    },
   
  },
})

// Action creators are generated for each case reducer function
export const { updateOrders } = orderSlice.actions

export default orderSlice.reducer